(function () {
  'use strict';

  var toastTimer;

  function ensureToast() {
    var toast = document.querySelector('[data-ap-cart-toast]');
    if (toast) return toast;

    var style = document.createElement('style');
    style.textContent = '.ap-cart-toast{position:fixed;z-index:2147483000;right:24px;bottom:24px;width:min(360px,calc(100vw - 32px));display:grid;grid-template-columns:38px 1fr;gap:13px;align-items:center;padding:18px 20px;border:1px solid rgba(255,255,255,.2);border-radius:14px;color:#fff;background:rgba(53,42,34,.94);box-shadow:0 20px 55px rgba(39,28,20,.25);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Noto Sans TC","Microsoft JhengHei",sans-serif;opacity:0;visibility:hidden;transform:translateY(16px);transition:opacity .25s ease,transform .25s ease,visibility .25s;pointer-events:none;backdrop-filter:blur(14px)}.ap-cart-toast.is-visible{opacity:1;visibility:visible;transform:translateY(0)}.ap-cart-toast__check{width:38px;height:38px;display:grid;place-items:center;border:1px solid rgba(255,255,255,.36);border-radius:50%;font-size:17px}.ap-cart-toast strong,.ap-cart-toast span{display:block}.ap-cart-toast strong{font-size:14px;font-weight:600;letter-spacing:.02em}.ap-cart-toast span{margin-top:4px;color:rgba(255,255,255,.78);font-size:12px;line-height:1.5}.ap-cart-toast.is-error{background:rgba(91,51,43,.96)}@media(max-width:560px){.ap-cart-toast{right:16px;bottom:16px}}';
    document.head.appendChild(style);

    toast = document.createElement('div');
    toast.className = 'ap-cart-toast';
    toast.setAttribute('data-ap-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<span class="ap-cart-toast__check" aria-hidden="true">✓</span><div><strong data-ap-cart-toast-title></strong><span data-ap-cart-toast-detail></span></div>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(title, detail, isError) {
    var toast = ensureToast();
    toast.classList.toggle('is-error', Boolean(isError));
    toast.querySelector('[data-ap-cart-toast-title]').textContent = title;
    toast.querySelector('[data-ap-cart-toast-detail]').textContent = detail || '';
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3600);
  }

  function updateCartCount(count) {
    var value = String(count || 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = value;
    });
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      bubble.classList.toggle('is-empty', count === 0);
      bubble.hidden = count === 0;
    });
    document.querySelectorAll('.aphrod-site-header__cart').forEach(function (link) {
      var badge = link.querySelector(':scope > span');
      if (count > 0 && !badge) {
        badge = document.createElement('span');
        link.appendChild(badge);
      }
      if (badge) {
        badge.textContent = value;
        badge.hidden = count === 0;
      }
      link.setAttribute('aria-label', '購物車，共 ' + value + ' 件商品');
    });
  }

  function getRoute(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + path;
  }

  function parseError(response) {
    return response.json().catch(function () { return {}; }).then(function (body) {
      throw new Error(body.description || body.message || '無法加入購物車，請稍後再試。');
    });
  }

  function add(formData, meta) {
    meta = meta || {};
    return fetch(getRoute('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (response) {
      if (!response.ok) return parseError(response);
      return response.json();
    }).then(function (item) {
      return fetch(getRoute('cart.js'), { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) return parseError(response);
        return response.json();
      }).then(function (cart) {
        var addedItem = item.items ? item.items[0] : item;
        var title = meta.productTitle || (addedItem && (addedItem.product_title || addedItem.title)) || '商品';
        var quantity = Number(meta.quantity || (addedItem && addedItem.quantity) || 1);
        updateCartCount(cart.item_count);
        showToast('已加入購物車', title + ' × ' + quantity, false);
        document.dispatchEvent(new CustomEvent('ap:cart-updated', { detail: { cart: cart, item: item } }));
        return { cart: cart, item: item };
      });
    });
  }

  function handleSubmit(event) {
    var form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.apAjaxCartIgnore === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();

    var submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter && (submitter.disabled || submitter.getAttribute('aria-busy') === 'true')) return;
    var formData = new FormData(form);
    var holder = form.closest('[data-product-title]');
    var title = form.dataset.productTitle || (holder && holder.dataset.productTitle) || '';
    var quantity = formData.get('quantity') || 1;

    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }
    add(formData, { productTitle: title, quantity: quantity }).catch(function (error) {
      showToast('無法加入購物車', error.message, true);
    }).finally(function () {
      if (submitter) {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
      }
    });
  }

  window.AphrodCart = {
    add: add,
    showToast: showToast,
    updateCount: updateCartCount
  };
  document.addEventListener('submit', handleSubmit, true);
})();
